import styled from '@emotion/styled';
import {
  BREAKPOINT_SMALL,
  DEFAULT_MOBILE_PADDING,
} from 'components/MarketingPagesShared/styles';

export const HomeSignupBackground = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg width='1439' height='854' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M610.426 309.724l3.041 1.162c269.775 102.588 545.422 162.068 817.671 180.18l7.862.511V856l-46.656-44.162c-219.777-201.592-479.439-368.897-769.1-496.505l-8.876-3.894-3.942-1.715zM0 0c149.493 96.279 309.748 182.495 480 256.44l-1.28-.557-3.025-1.158C321.007 195.645 164.951 149.88 9.27 115.908l-4.815-1.047L0 113.899V0z' fill='%23FFF' fill-rule='nonzero' fill-opacity='.35'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    background-position: center top;
    background-size: 100% auto;
  }
`;
export const HomeSignupContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60%;
  padding-top: 280px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: auto;
    padding: 0 ${DEFAULT_MOBILE_PADDING}px 0 ${DEFAULT_MOBILE_PADDING}px;
  }
`;

export const HomeSignupHeader = styled.h3`
  margin-bottom: 40px;
  font-weight: 800;
  font-size: 4rem;
  line-height: 1.15;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    font-size: 2.5rem;
  }
`;

export const HomeSignupText = styled.p`
  width: 80%;
  margin-bottom: 40px;
  color: inherit;
  font-size: 1.25rem;
  line-height: 1.5;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: auto;
  }
`;

export const HomeSignupButton = styled.div`
  margin-bottom: 30px;
`;

export const HomeSignupFooter = styled.div`
  font-weight: bold;
`;
